import { Component } from '@angular/core';

@Component({
  selector: 'app-pie-chart-custom',
  template: '<app-chart-output></app-chart-output>',
  
})
export class PieChartComponentCustom {

}
